import { render, staticRenderFns } from "./LAndDRequest.vue?vue&type=template&id=dc447de6"
import script from "./LAndDRequest.vue?vue&type=script&lang=js"
export * from "./LAndDRequest.vue?vue&type=script&lang=js"
import style0 from "./LAndDRequest.vue?vue&type=style&index=0&id=dc447de6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports